import { z } from "zod";
import { InboxActionKind } from "./inbox";
import { DIGEST_CADENCES } from "./notifications";

/**
 * The Morning Nob (PRD FR-7). The read endpoints (preview, latest) return the
 * recap JSON assembled server-side; these schemas cover the two mutating/tuning
 * endpoints, validated at the trust boundary.
 */

/**
 * FR-7.2 — the recipient tunes cap/cadence/hour directly (a settings PATCH).
 *
 * The cadences are the contract's three (ruling R-0910-3): `custom` is gone with
 * the regex parser that invented it, and `weekly` is real, which it was not —
 * the settings panel has offered a Weekly button since M16 and this validator
 * answered 400 to every press of it.
 */
export const RecapConfigPatchRequest = z
  .object({
    cap: z.number().int().min(1).max(25).optional(),
    cadence: z.enum(DIGEST_CADENCES).optional(),
    hour: z.number().int().min(0).max(23).optional(),
    enabled: z.boolean().optional(),
  })
  .refine((v) => Object.keys(v).length > 0, { message: "at least one field required" });
export type RecapConfigPatchRequest = z.infer<typeof RecapConfigPatchRequest>;

/** FR-7.3 — a one-tap action on a knock from the recap card. Reuses inbox actions. */
export const RecapActionRequest = z.object({
  knock_id: z.uuid(),
  action: InboxActionKind,
  reason_chip: z.string().trim().max(64).optional(),
  note: z.string().trim().max(5000).optional(),
});
export type RecapActionRequest = z.infer<typeof RecapActionRequest>;
